import React from 'react';
import "./CustomScrollbar.css"

function CustomScrollbar({ children }) {
  return (
    <div className="custom-scrollbar">
      {children}
    </div>
  );
}

export default CustomScrollbar;